import axios, { type AxiosError, type AxiosResponse } from "axios";
import { ERRORS } from "constants/error-constants";
import type { ApiRequestError } from "models/error/Error";
import type { AnsweredQuestion, Question, TestResult } from "models/test/Test";
import cookieStorage from "persistence";
import { generatePathRoute } from "utils/pathBuilder";
import { CustomError, handlingResponse, logError } from "../utils";

const getChapterTest = async (chapterId: string, bookId: string): Promise<Question[]> => {
  try {
    const result = await axios.get(
      generatePathRoute(`/api/additionals/book/${bookId}/chapters/${chapterId}/exam`),
      { headers: { Authorization: cookieStorage.getToken() } },
    );
    return handlingResponse<Question[]>(
      [200],
      `Error getting chapter exam for chapterId ${chapterId}`,
    )(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new CustomError({ message, status, type: ERRORS.GET_CHAPTER_TEST_FAILED });
  }
};

const getTestResults = async (): Promise<TestResult[]> => {
  try {
    const results = await axios.get(generatePathRoute("/api/additionals/chapters/results"), {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<TestResult[]>([200], "Error getting chapter exam results")(results);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new CustomError({ message, status, type: ERRORS.GET_TEST_RESULTS });
  }
};

const postTestResult = async (
  chapterId: string,
  testResult: AnsweredQuestion[],
): Promise<AxiosResponse> => {
  try {
    const result = await axios.post(
      generatePathRoute(`/api/additionals/chapters/${chapterId}/results`),
      testResult,
      { headers: { Authorization: cookieStorage.getToken() } },
    );
    return handlingResponse<AxiosResponse>(
      [200],
      `Error storing chapter exam result for chapterId ${chapterId}`,
    )(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new CustomError({ message, status, type: ERRORS.POST_TEST_RESULT_FAILED });
  }
};

export { getChapterTest, getTestResults, postTestResult };
